export default __webpack_public_path__ + "static/depth-20dc21d97a6a927c2bc3569da39a15c2.png";